import { render, staticRenderFns } from "./OnldfComponent.vue?vue&type=template&id=2b08af52&scoped=true&"
import script from "./OnldfComponent.vue?vue&type=script&lang=js&"
export * from "./OnldfComponent.vue?vue&type=script&lang=js&"
import style0 from "./OnldfComponent.vue?vue&type=style&index=0&id=2b08af52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b08af52",
  null
  
)

export default component.exports